import React, { useEffect, useState } from "react";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Collapse,
  Divider,
  Tooltip,
  Dialog,
  DialogContent,
  DialogTitle,
  autocompleteClasses,Menu, MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  ExpandMore,
  ExpandLess,
  Clear as ClearIcon,
  ImageOutlined as ImageOutlinedIcon,
  AttachFile as AttachFileIcon,
  ModeEditOutlineRounded as ModeEditOutlineRoundedIcon,
} from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { FormatDate, FormatDateShort } from "../../utils/common/DateUtils";
import { useSelector } from "react-redux";
import { CON_DEFAULT_IMG, CON_DEFAULT_NOIMAGE, CON_DEFAULT_PNG, CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { externalgetApi } from "../../services/externalApis";
import { SETTING_API_03, SETTING_API_05, SETTING_API_09 } from "../../api/ApiModel";
import {
  FormatCurrencyLKR,
  formatWithCommas,
} from "../../utils/common/CurrencyFormatter";
import ImagePopUp from "../grn/grnpopup/ImagePopUp";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { RETURN_STATUS_CODE } from "../../utils/sys/GrnConstants";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
const ViewDataGridGrnDetailstable = ({
  grnItems,
  grnReturns,
  grnRejectList = [],
  grnData = [],
  grnDocuments,
  origin,
  grnreturncode,
  grnReturnList = [],
       grnHeader,
}) => {
  // console.log("grnItems returnnnnnnn", grnReturns);
  const theme = useTheme();
  const styles = useStyles(theme);
  const [imagePreviewOpen, setImagePreviewOpen] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState(null);
  const [expanded, setExpanded] = useState([]);
  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, STAFFMAPLOCODE } = SYS_USER.USER_PARAM || {};
 const [grnDocTypes, setGrnDocTypes] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
    const [anchorEl, setAnchorEl] = useState({});
  // Prefer grnItems when navigating from Create/Edit so we show the processed values (tax/gross).
  const shouldUseGrnItems =
    (origin && ["editgrn", "creategrn"].includes(String(origin).toLowerCase())) ||
    (Array.isArray(grnItems) && grnItems.length > 0);

  const grnItemsData = shouldUseGrnItems
    ? grnItems || []
    : Array.isArray(grnData?.products)
    ? grnData.products.filter((item) => item.isAdded === true)
    : grnItems || [];


  console.log("grnItemsData itemAttachments:", grnItemsData.map((item, idx) => ({
  index: idx,
  productname: item.productname,
  attachments: item.itemAttachments?.attachments || [],
})));

const [viewDialogOpen, setViewDialogOpen] = useState(false);
const [selectedReturnItem, setSelectedReturnItem] = useState(null);

  const handleMenuOpen = (
    event,
    index,
  ) => setAnchorEl((prev) => ({ ...prev, [index]: event.currentTarget }));
  const handleMenuClose = (index) =>
    setAnchorEl((prev) => ({ ...prev, [index]: null }));


const grnReturnsData = (
  Array.isArray(grnReturnList)
    ? grnReturnList
    : []
).filter(
  (item) =>
    String(item.grnreturncode) === String(grnreturncode)
);
  
  // Debug: Log the returns data structure
  console.log("grnReturnsData structure:", grnReturnsData);
  if (grnReturnsData.length > 0) {
    console.log("First return item structure:", grnReturnsData[0]);
    console.log("First return item keys:", Object.keys(grnReturnsData[0] || {}));
  }
  
  const [mouList, setMouList] = useState([]);
  const [open, setOpen] = useState(false); // State to manage dialog visibility

  const handleExpandClick = (index) => {
    setExpanded((prev) => {
      const newExpanded = prev.map(() => false);
      newExpanded[index] = true;
      return newExpanded;
    });
  };

  const getMouNameByCode = (code) => {
    const mou = mouList.find((b) => b.immeasuringunitcode === code);
    return mou ? mou.immeasuringunit : "No-MOU";
  };
  const isImage = (filename) => {
    return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filename);
  };

  const handleOpen = () => {
    setOpen(true); // Open the dialog
  };

  const handleClose = () => {
    setOpen(false); // Close the dialog
  };

  useEffect(() => {
    fetchMou();
  }, []);

  const fetchMou = async () => {
    try {
      const params = {
        COMPCODE,
        LOCCODE: STAFFMAPLOCODE,
        STS: CON_STATUS_ACTIVE,
      };
      const response = await externalgetApi(SETTING_API_05, "GET", params);
      setMouList(response || []);
    } catch (error) {
      console.error("Error fetching brands:", error);
      setMouList([]);
    }
  };

  const RETURN_STATUS_CODES = RETURN_STATUS_CODE;

  const grnRejectData = Array.isArray(grnRejectList) ? grnRejectList : [];

  // Prefer explicit rejectList data; otherwise, derive reject candidates
  // from returns by excluding known return-status codes.
  const rejectSourceData =
    grnRejectData.length > 0
      ? grnRejectData
      : Array.isArray(grnReturnsData)
      ? grnReturnsData.filter((item) => {
          const sts = String(item?.sts ?? "").trim();
          return (
            sts &&
            sts !== "null" &&
            sts !== "undefined" &&
            !RETURN_STATUS_CODES.includes(sts)
          );
        })
      : [];

const filteredRejectItems = rejectSourceData.filter((item) => {
  const sts = String(item?.sts ?? "").trim();
  return (
    !RETURN_STATUS_CODES.includes(sts) &&
    sts !== "" &&
    sts !== "null" &&
    sts !== "undefined"
  );
});

  const isPDF = (fileName) => {
    return fileName?.toLowerCase().endsWith(".pdf");
  };
  useEffect(() => {
    // Fetch directly with known DOCCATCODE=1 (Item Based) to avoid category lookup mismatch.
    fetchGrnDocType("1");
    fetchGrnDocCategory();
  }, []);
  
  const fetchGrnDocCategory = async () => {
    try {
      const params = { STS: CON_STATUS_ACTIVE };
      const response = await externalgetApi(SETTING_API_09, "GET", params);
      const grnCategory = Array.isArray(response)
        ? response.find((cat) => cat.doccatname === "Item-Based Document Types")
        : null;

      if (grnCategory?.doccatcode) {
        await fetchGrnDocType(grnCategory.doccatcode);
      } else {
        // Fallback to the known working category code
        await fetchGrnDocType("1");
      }
      console.log("grnCategory", grnCategory);
    } catch (error) {
      console.error("Error fetching GRN document category", error);
      // Fallback to direct fetch with code 1 if category call fails
      await fetchGrnDocType("1");
    }
  };

    // Add this inside your component
const getDocTypeName = (code) => {
  const found = grnDocTypes.find(
    (doc) => String(doc.doctypecode) === String(code)
  );
  return found ? found.doctype : code || "-";
};
  
    const fetchGrnDocType = async (docCatCode) => {
      try {
        const params = {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,
          DOCCATCODE: docCatCode,
          STS: CON_STATUS_ACTIVE,
        };
        const response = await externalgetApi(SETTING_API_03, "GET", params);
        setGrnDocTypes(response); // Save doc types to state
         console.log("grnDocTypes", response);
      } catch (error) {
        console.error("Error fetching GRN document types", error);
      }
    };
  // console.log("yy rejectedItems", filteredRejectItems);

  // Helper function to get attachments from return items with specific statuses
  const getSts7Attachments = (grnReturnsData) => {
    if (!Array.isArray(grnReturnsData)) return [];

    const allowedStatuses = RETURN_STATUS_CODE;

    return grnReturnsData
      .filter(
        (item) =>
          allowedStatuses.includes(String(item.sts)) && item.docpathjson //  ensure it's `sts` (not `trsts`)
      )
      .flatMap((item) => {
        try {
          const attachments = JSON.parse(item.docpathjson);
          return attachments.map((attachment) => ({
            ...attachment,
            productcode: item.productcode,
            supproductcode: item.supproductcode,
            grnreturndetcode: item.grnreturndetcode, // Include this for better matching
          }));
        } catch (err) {
          console.warn("Invalid JSON in docpathjson:", item.docpathjson);
          return [];
        }
      });
  };

  // Compute return attachments once, outside the map loop
  const ReturnAttachmentsToShow = getSts7Attachments(grnReturnsData);

 return (
  <TableContainer component={Paper} sx={{ border: '0.5px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', boxShadow: 'none' ,mt: 2}}>
    <Table sx={{ tableLayout: 'auto' }}>
      <TableHead>
   <TableRow sx={{ backgroundColor: 'action.hover' }}>

  <TableCell sx={{ fontSize: 12, fontWeight: 500, color: 'text.secondary', whiteSpace: 'nowrap', py: 1.25, px: 1.5 }}>
    Item Code
  </TableCell>

  <TableCell sx={{ fontSize: 12, fontWeight: 500, color: 'text.secondary', whiteSpace: 'nowrap', py: 1.25, px: 1.5 }}>
    Item Name
  </TableCell>

  <TableCell sx={{ fontSize: 12, fontWeight: 500, color: 'text.secondary', whiteSpace: 'nowrap', py: 1.25, px: 1.5 }}>
    UOM
  </TableCell>

  <TableCell align="right"  sx={{ fontSize: 12, fontWeight: 500, color: 'text.secondary', whiteSpace: 'nowrap', py: 1.25, px: 1.5 }}>
   Total Quantity
  </TableCell>

  <TableCell align="right" sx={{ fontSize: 12, fontWeight: 500, color: 'text.secondary', whiteSpace: 'nowrap', py: 1.25, px: 1.5 }}>
    Returned Quantity
  </TableCell>

  

  <TableCell align="right" sx={{ fontSize: 12, fontWeight: 500, color: 'text.secondary', whiteSpace: 'nowrap', py: 1.25, px: 1.5 }}>
    Unit Cost
  </TableCell>

 <TableCell align="right" sx={{ fontSize: 12, fontWeight: 500, color: 'text.secondary', whiteSpace: 'nowrap', py: 1.25, px: 1.5 }}>
    Tax Rate
  </TableCell>

  <TableCell align="right" sx={{ fontSize: 12, fontWeight: 500, color: 'text.secondary', whiteSpace: 'nowrap', py: 1.25, px: 1.5 }}>
    Tax Amount Per Unit
  </TableCell>

  <TableCell align="right" sx={{ fontSize: 12, fontWeight: 500, color: 'text.secondary', whiteSpace: 'nowrap', py: 1.25, px: 1.5 }}>
    Tax Amount
  </TableCell>

  <TableCell align="right" sx={{ fontSize: 12, fontWeight: 500, color: 'text.secondary', whiteSpace: 'nowrap', py: 1.25, px: 1.5 }}>
    Total Price
  </TableCell>
   <TableCell align="right" sx={{ fontSize: 12, fontWeight: 500, color: 'text.secondary', whiteSpace: 'nowrap', py: 1.25, px: 1.5 }}>
   Action
  </TableCell>

</TableRow>
      </TableHead>
      <TableBody>
{grnReturnsData.map((item, index) => {

  const returnMatch = grnItemsData.find(
    (ret) =>
      String(ret.productcode) === String(item.productcode) ||
      String(ret.supproductcode) === String(item.supproductcode)
  );

  const returnedQty = Number(returnMatch?.returnedqty || 0);
  const taxRate = Number(item.taxrate || 0);
  const taxPerUnit = Number(item.perunittaxvalue || 0);

  const unitCost =
    Number(item.perunittaxableamount || 0) +
    Number(item.perunitchargevalue || 0);

              
const taxApplied =
  grnHeader?.isvat === "Y"
    ? Number(item.taxamount || 0)
    : 0;

const totalPrice =
  Number(item.totalbeforetax || 0) + taxApplied;

  return (
    <TableRow
      key={item.id || index}
      sx={{
        '&:last-child td': { borderBottom: 0 },
        '&:hover': { backgroundColor: 'action.hover' }
      }}
    >

      <TableCell sx={styles.cellSx}>
        {item.productcode || '-'}
      </TableCell>

      <TableCell sx={styles.cellSx}>
        {item.productname || '-'}
      </TableCell>

      <TableCell sx={styles.cellSx}>
        {item.immeasuringunit ||
          getMouNameByCode(item.immeasuringunitcode) ||
          '-'}
      </TableCell>

      <TableCell align="right" sx={styles.cellSx}>
        {formatWithCommas(returnMatch?.acceptedqty || 0)}
      </TableCell>
          
      {/* ✅ ALWAYS show item, not only return data */}
      <TableCell  sx={styles.cellSx} align="right">
        {item.returnedqty}
      </TableCell>

     

      <TableCell align="right" sx={styles.cellSx}>
       {FormatCurrencyLKR(
  (Number(item.unitcostwithouttax) || 0) +
  (Number(item.perunitchargevalue) || 0)
)}
      </TableCell>
       <TableCell align="right" sx={styles.cellSx}>
     {(returnMatch?.taxrate || taxRate)}%
      </TableCell>

      <TableCell align="right" sx={styles.cellSx}>
     {FormatCurrencyLKR(item.taxperunit)}
      </TableCell>

      <TableCell align="right" sx={styles.cellSx}>
        {FormatCurrencyLKR(item.taxamount)}
      </TableCell>

      <TableCell align="right" sx={styles.cellSx}>
    {FormatCurrencyLKR(totalPrice)}
      </TableCell>
   <TableCell align="right" sx={styles.cellSx}>
        <Box
                                 sx={{
                                   display: "flex",
                                   alignItems: "center",
                                   justifyContent: "center",
                                   gap: 0.25,
                                 }}
                               >
                              
                                <IconButton
  size="small"
  onClick={(e) => handleMenuOpen(e, index)}  // idx → index
>
  <MoreVertIcon fontSize="small" />
</IconButton>

<Menu
  anchorEl={anchorEl[index]}               // idx → index
  open={Boolean(anchorEl[index])}          // idx → index
  onClose={() => handleMenuClose(index)}   // idx → index
  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
  transformOrigin={{ vertical: "top", horizontal: "right" }}
  PaperProps={{
    elevation: 2,
    sx: {
      borderRadius: 1.5,
      minWidth: 160,
      border: "1px solid",
      borderColor: "divider",
      "& .MuiMenuItem-root": {
        fontSize: "0.83rem",
        gap: 1,
        py: 1,
        px: 1.5,
      },
    },
  }}
>
  <MenuItem
    onClick={() => {
      handleMenuClose(index);
      setSelectedReturnItem(item);
      setViewDialogOpen(true);
    }}
  >
    <VisibilityOutlinedIcon fontSize="small" sx={{ color: "text.secondary" }} />
    View
  </MenuItem>
 
</Menu>
                               </Box>
   </TableCell>
    </TableRow>
  );
})}
      </TableBody>
    </Table>
    <Dialog
  open={viewDialogOpen}
  onClose={() => setViewDialogOpen(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
    <Box>
     
    </Box>
    <IconButton size="small" onClick={() => setViewDialogOpen(false)}>
      <CloseIcon fontSize="small" />
    </IconButton>
  </DialogTitle>



  <DialogContent sx={{ pt: 2 }}>
    {selectedReturnItem && (() => {
      let attachments = [];
      try {
        attachments = JSON.parse(selectedReturnItem.docpathjson || "[]");
      } catch { attachments = []; }

      return (
        <Grid container spacing={2}>
          {/* Reason */}
          <Grid size={6}>
            <Typography  color="text.primary" >
              Reason
            </Typography>
            <Typography variant="body2" mt={0.5}>
              {selectedReturnItem.reason || "-"}
            </Typography>
          </Grid>

          {/* Remark (from first attachment) */}
          <Grid size={6}>
              <Typography color="text.primary" >
              Remark
            </Typography>
             <Typography variant="body2" mt={0.5}>
     {selectedReturnItem.descrip || "-"}
            </Typography>
          </Grid>

          {/* Documents */}
          <Grid size={12}>
              <Typography color="text.primary" >
              Documents
            </Typography>
            {attachments.length === 0 ? (
              <Typography variant="body2" color="text.disabled" mt={0.5}>No documents attached</Typography>
            ) : (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
                {attachments.map((att, i) => {
              
                  return (
                    <Box
                      key={i}
                      
                      
                    >
                     
                   

                        {att.FILEPATH  && att.FILEPATH  !== CON_DEFAULT_PNG ? (
                                          <Box
                                            component="a"
                                            href={att.FILEPATH}
                                            target="_blank"
                                            sx={{
                                              display: "inline-flex",
                                              alignItems: "center",
                                              gap: 0.5,
                                              fontSize: theme.typography.body_xs,
                                              fontWeight: 600,
                                             
                                             color: theme.palette.text.primary,
                                              textDecoration: "none",
                                            }}
                                          >
                                            <InsertDriveFileIcon sx={{ fontSize: 20 }} />
                                       
                                          </Box>
                                        ) : (
                                             <Box
                                                          component="a"
                                                        
                                                          sx={{
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: 0.5,
                                                            fontSize: theme.typography.subtitle_xs,
                                                           
                                                            color: theme.palette.text.primary,
                                                            textDecoration: "none",
                                                             filter: (theme) =>
      theme.palette.mode === "dark"
        ? "invert(1)"
        : "none",
                                                          }}
                                                        >
                                                      <img
                                                    
                                      src={CON_DEFAULT_NOIMAGE}
                                      alt=""
                                      height={30}
                                      width={30}
                                    /> </Box>
                                        )}
                    </Box>
                  );
                })}
              </Box>
            )}
          </Grid>
        </Grid>
      );
    })()}
  </DialogContent>
</Dialog>
  </TableContainer>
);


};

export default ViewDataGridGrnDetailstable;
